import { render, staticRenderFns } from "./ValidateEmail.vue?vue&type=template&id=6870b132&scoped=true&"
import script from "./ValidateEmail.vue?vue&type=script&lang=js&"
export * from "./ValidateEmail.vue?vue&type=script&lang=js&"
import style0 from "./ValidateEmail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ValidateEmail.vue?vue&type=style&index=1&id=6870b132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6870b132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/private_library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6870b132')) {
      api.createRecord('6870b132', component.options)
    } else {
      api.reload('6870b132', component.options)
    }
    module.hot.accept("./ValidateEmail.vue?vue&type=template&id=6870b132&scoped=true&", function () {
      api.rerender('6870b132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ValidateEmail.vue"
export default component.exports